import httpRequest from './httpRequest'

const api = '/loopback/api/Sandboxes'
const prefix = api

const routeVerdicts = prefix + '/verdicts'
const routeVerdict = prefix + '/verdict'
const routeVerdictClassification = routeVerdict + '-classification'

const routeVerdictOverride = routeVerdict + '/override'
const routeVerdictOverrideGet = routeVerdictOverride + '-get'
const routeVerdictOverridePut = routeVerdictOverride + '-put'
const routeVerdictOverrideDelete = routeVerdictOverride + '-delete'

const routeRecords = prefix + '/records/'
const routeGraywareDownload = prefix + '/grayware-download/'

function plugin (Vue) {
  if (plugin.installed) {
    return
  }

  const apiSandbox = new Vue({
    methods: {
      graywareDownloadLink (sha1Checksum, size) {
        var url = routeGraywareDownload
        url += httpRequest.queryStringWithAuth({
          sha1: sha1Checksum,
          size: size
        })
        return url
      },

      fetchVerdicts (epochStart, epochEnd) {
        var url = routeVerdicts
        url += httpRequest.queryStringWithAuth()
        return httpRequest.get(url, this.$redirectLogin)
      },

      fetchVerdict (sha1Checksum, size) {
        var url = routeVerdict + '/' + sha1Checksum + '/' + size
        url += httpRequest.queryStringWithAuth()
        return httpRequest.get(url, this.$redirectLogin)
      },

      fetchVerdictClassifications () {
        var url = routeVerdictClassification
        url += httpRequest.queryStringWithAuth()
        return httpRequest.get(url, this.$redirectLogin)
      },

      fetchVerdictOverride (sha1Checksum, size) {
        var url = routeVerdictOverrideGet + '/' + sha1Checksum + '/' + size
        url += httpRequest.queryStringWithAuth()
        return httpRequest.get(url, this.$redirectLogin)
      },

      updateVerdictOverride (sha1Checksum, size, classification) {
        var url = routeVerdictOverridePut + '/' + sha1Checksum + '/' + size
        var data = {
          classification: classification
        }
        url += httpRequest.queryStringWithAuth()
        return httpRequest.put(url, data, this.$redirectLogin)
      },

      deleteVerdictOverride (sha1Checksum, size) {
        var url = routeVerdictOverrideDelete + '/' + sha1Checksum + '/' + size
        url += httpRequest.queryStringWithAuth()
        return httpRequest.delete(url, this.$redirectLogin)
      },

      fetchRecords (sha1Checksum, size) {
        var url = routeRecords + sha1Checksum + '/' + size
        url += httpRequest.queryStringWithAuth()
        return httpRequest.get(url, this.$redirectLogin)
      }

    }
  })

  Object.defineProperty(Vue.prototype, '$apiSandbox', {
    get () {
      return apiSandbox
    }
  })
}

if (typeof window !== 'undefined' && window.Vue) {
  window.Vue.use(plugin)
}

export default plugin



// WEBPACK FOOTER //
// ./src/apiSandbox.js